import createAPI from '../axios'

// 实习管理相关API
const internshipManage = {
	internshipIntention: {
	    list: config => createAPI('/internshipIntention/list', 'post', config),
        initOption: config => createAPI('/internshipIntention/initOption', 'post', config),
        save: config => createAPI('/internshipIntention/save', 'post', config),
		importInterntionInfo: config => createAPI('/internshipIntention/importInterntionInfo', 'post', config),
	},
    internshipUnit: {
        list: config => createAPI('/internshipUnit/list', 'post', config),
        initOption: config => createAPI('/internshipUnit/initOption', 'post', config),
        saveUnit: config => createAPI('/internshipUnit/saveUnit', 'post', config),
        delUnit: config => createAPI('/internshipUnit/delUnit', 'post', config),
    },
    internshipArrangement: {
        list: config => createAPI('/internshipArrangement/list', 'post', config),
        initOption: config => createAPI('/internshipArrangement/initOption', 'post', config),
        unitOption: config => createAPI('/internshipArrangement/unitOption', 'post', config),
        saveArrange: config => createAPI('/internshipArrangement/saveArrange', 'post', config),
        delArrange: config => createAPI('/internshipArrangement/delArrange', 'post', config),
    },
    internshipPatrol: {
        list: config => createAPI('/internshipPatrol/list', 'post', config),
        initOption: config => createAPI('/internshipPatrol/initOption', 'post', config),
        savePatrol: config => createAPI('/internshipPatrol/savePatrol', 'post', config),
        delPatrol: config => createAPI('/internshipPatrol/delPatrol', 'post', config),
        uploadMultiFile: config => createAPI('/internshipPatrol/uploadMultiFile', 'post', config),
        attachmentList: config => createAPI('/internshipPatrol/attachmentList', 'post', config),
        delFile: config => createAPI('/internshipPatrol/delFile', 'post', config),
        savePracticeScore: config => createAPI('/internshipPatrol/savePracticeScore', 'post', config),
    },
    internshipStatistics: {
        list: config => createAPI('/internshipStatistics/list', 'post', config),
        initOption: config => createAPI('/internshipStatistics/initOption', 'post', config),
        classlist: config => createAPI('/internshipStatistics/classlist', 'post', config),
        unitlist: config => createAPI('/internshipStatistics/unitlist', 'post', config),
        arrangelist: config => createAPI('/internshipStatistics/arrangelist', 'post', config),
        importInterntionScore: config => createAPI('/internshipStatistics/importInterntionScore', 'post', config),
    }
};

export default internshipManage;



// WEBPACK FOOTER //
// ./src/api/modules/internshipManage.js